/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationErrorStatusKind =
  (typeof FilterConversationErrorStatusKind)[keyof typeof FilterConversationErrorStatusKind];

export const FilterConversationErrorStatusKind = {
  conversation_error_status: 'conversation_error_status',
} as const;
